var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFfCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 48,
    viewBox: "0 0 77 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Credit Card"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 17.3923V40.3743C0 44.5857 3.55986 48.006 7.93989 48.0001L68.2598 47.9885C72.6398 47.9885 76.1939 44.5682 76.1939 40.3569V17.3865H0V17.3923ZM65.9971 39.7171C66.032 40.4442 66.0669 41.02 66.1425 41.6424H62.2627C62.3325 41.02 62.3907 40.4441 62.4081 39.6996C59.2147 39.4029 58.1852 38.3094 58.1852 36.3317C58.1852 36.035 58.2026 35.7442 58.2375 35.4126C58.8308 35.465 59.6975 35.5173 60.5642 35.5173C61.1575 35.5173 61.681 35.5173 62.0998 35.4824V35.7267C62.0998 36.7505 62.5884 37.1519 64.1939 37.1519C65.7993 37.1519 66.2356 36.7505 66.2356 36.0932C66.2356 35.3138 65.7819 34.8077 63.3679 34.482C59.238 33.9468 58.2259 32.6264 58.2259 30.3172C58.2259 28.2697 59.4532 27.0888 62.4139 26.7631C62.3965 26.0011 62.3441 25.4078 62.2685 24.768H66.1483C66.096 25.3904 66.0378 25.9837 66.0029 26.7282C69.2312 26.9551 70.2608 27.8741 70.2608 30.0961C70.2608 30.3404 70.2433 30.5964 70.2259 30.893C69.6849 30.8407 68.8008 30.8058 68.0271 30.8058C67.4164 30.8058 66.8172 30.8232 66.4391 30.8407C66.4566 30.7185 66.4566 30.5964 66.4566 30.4917C66.4566 29.5726 65.9331 29.276 64.3451 29.276C62.8851 29.276 62.4663 29.6599 62.4663 30.2299C62.4663 30.9046 62.792 31.4282 65.4445 31.8062C69.144 32.3414 70.4411 33.4698 70.4411 35.9711C70.4411 38.1058 69.2661 39.4262 66.0029 39.7171H65.9971Z",
    fill: "#E81111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M76.1939 12.634V7.62579C76.1939 3.41445 72.6398 -0.00580936 68.254 7.40836e-06L7.93407 0.0116412C3.55405 0.0116412 0 3.4319 0 7.64324V12.6399H76.1939V12.634Z",
    fill: "#E81111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfCreditCard);
export default __webpack_public_path__ + "static/media/FFCreditCard.58c77902674becc17c2322e9a7be06ee.svg";
export { ForwardRef as ReactComponent };